export default __webpack_public_path__ + "static/media/v1-sec.bf1d2f22.png";